import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.login').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider.state('app.login', {
            component: 'login',
            data: {
                authorizedRole: null
            }
        });
    }
})();
